import * as React from 'react';

const NotFound = () => (
    <div>THESE ARE NOT THE DROIDS YOU ARE LOOKING FOR</div>
);

export default NotFound;
